<template>
  <Pagination
    :page="page"
    :per-page="pageSize"
    :options="perPageOptions"
    :total-count="totalCount"
    @change="handlePageChange"
  >
    <div class="sort-field" v-if="!simplified">
      <v-select
        v-model="orderBy"
        :items="sortTypes"
        :label="$t('message.reviews.sort')"
        item-text="label"
        item-value="value"
        :disabled="isLoading"
        hide-details
        dense
        outlined
        rounded
        full-width
        append-icon="icon-arrow-down"
        class="sort-field__select"
        @change="handleOrderByChange"
      >
      </v-select>
    </div>
  </Pagination>
</template>

<script>
import Pagination from "@/components/List/Pagination";

export default {
  name: "ReviewBoosterPageControls",
  components: {
    Pagination
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      required: true
    },
    pageParams: {
      type: Object,
      required: true
    },
    perPageOptionsList: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    simplified: {
      type: Boolean,
      default: false
    },
    defaultOrder: {
      type: String
    }
  },
  data() {
    return {
      page: null,
      pageSize: null,
      perPageOptions: null,
      orderBy: null,
      sortTypes: [
        { label: this.$t("message.reviews.ratingDesc"), value: "-rating" },
        { label: this.$t("message.reviews.ratingAsc"), value: "rating" },
        {
          label: this.$t("message.reviews.createDateDesc"),
          value: "-created_at"
        },
        {
          label: this.$t("message.reviews.createDateAsc"),
          value: "created_at"
        }
      ]
    };
  },

  methods: {
    handlePageChange(
      { page, perPage } = {
        page: this.page,
        perPage: this.pageSize
      }
    ) {
      this.page = page;
      this.pageSize = perPage;
      this.$emit("page-change", { page, pageSize: perPage });
    },

    handleOrderByChange(orderBy) {
      this.$emit("order-by-change", orderBy);
    }
  },
  watch: {
    pageParams: {
      immediate: true,
      deep: true,
      handler() {
        this.page = this.pageParams.page;
        this.pageSize = this.pageParams.pageSize;
        this.perPageOptions = this.perPageOptionsList;
      }
    },
    defaultOrder(current) {
      this.orderBy = this.sortTypes.find(item => item.value === current);
    }
  }
};
</script>
<style lang="scss" scoped>
.sort-field {
  width: 260px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

::v-deep .sort-field__select {
  width: 100%;
  height: 100%;
  flex-shrink: 0;

  &.v-text-field--outlined.v-input--dense.v-text-field--outlined {
    > .v-input__control {
      > .v-input__slot {
        padding-left: $spacing;
        padding-right: 0;
        min-height: 46px;
        height: 46px;
        @include font-size(14px);
        line-height: 17px;
        font-weight: normal;
      }
    }

    fieldset {
      border-color: rgba($text, 0.08);
      border-width: 1px;
      border-radius: $container-border-radius;
    }
  }

  &.v-text-field--outlined.v-input--dense.v-input--is-focused fieldset {
    border-color: $primary;
  }

  &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
    .v-input__append-inner {
    width: 30px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: $spacing * 1.5;
    padding-left: $spacing;
  }

  .v-select__selection--comma {
    margin-left: $spacing * 1.5 !important;
  }

  .v-label {
    @include font-size(14px);
    line-height: 17px;
    font-weight: normal;
    color: $dark-blue-3;
    padding-left: $spacing * 1.5;
    margin: $spacing / 8 0;
  }
}
</style>
